function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 2C0 0.895431 0.895431 0 2 0H63.4884C64.5929 0 65.4884 0.895431 65.4884 2V42C65.4884 43.1046 64.5929 44 63.4884 44H2C0.895429 44 0 43.1046 0 42V2Z",
  fill: "url(#paint0_linear_423_35653)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33.5873 19.3956C33.5592 21.6049 35.5562 22.8379 37.0605 23.5709C38.6062 24.323 39.1253 24.8053 39.1194 25.4778C39.1076 26.5073 37.8864 26.9615 36.7434 26.9792C34.7494 27.0102 33.5902 26.4409 32.6684 26.0103L31.9502 29.3714C32.8749 29.7977 34.5872 30.1693 36.3629 30.1855C40.5308 30.1855 43.2578 28.1281 43.2726 24.9381C43.2888 20.8896 37.6726 20.6654 37.7109 18.8558C37.7242 18.3072 38.2478 17.7216 39.3952 17.5727C39.963 17.4975 41.5308 17.44 43.308 18.2585L44.0056 15.0065C43.0499 14.6584 41.8213 14.3251 40.2919 14.3251C36.3688 14.3251 33.6094 16.4105 33.5873 19.3956ZM50.7087 14.6053C49.9477 14.6053 49.3061 15.0492 49.02 15.7306L43.0661 29.9466H47.231L48.0599 27.6562H53.1496L53.6304 29.9466H57.3013L54.0979 14.6053H50.7087ZM51.2913 18.7496L52.4933 24.5104H49.2014L51.2913 18.7496ZM28.5374 14.6053L25.2544 29.9466H29.2232L32.5047 14.6053H28.5374ZM22.666 14.6053L18.535 25.0472L16.864 16.1686C16.6679 15.1775 15.8936 14.6053 15.0337 14.6053H8.28043L8.18604 15.0507C9.57239 15.3516 11.1475 15.8368 12.1017 16.3559C12.6858 16.673 12.8524 16.9503 13.0442 17.7039L16.2092 29.9466H20.4036L26.834 14.6053H22.666Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_423_35653",
  x1: 29.4186,
  y1: 44,
  x2: 42.9511,
  y2: 0.957039,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#222357"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#254AA5"
})));

function SvgVisaMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 44,
    viewBox: "0 0 66 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaMedium);
export default __webpack_public_path__ + "static/media/visa-medium.32e2cce2.svg";
export { ForwardRef as ReactComponent };